import { useFormik } from "formik";
import React, { useContext, useState } from "react";
import ReportForm from "../components/Reports/ReportForm";
import { initialValues, validationSchema } from "../utils/formsUtili/CreateReport";
import FullHeightWrapper from "./../components/Common/FullHeightWrapper";
import Wrapper from "./../components/Common/Wrapper";
import { createReport } from "./../services/reportsService";
import { AuthContext } from "../context/Auth";
import CustomLoading from "../components/Common/CustomLoading";
import { NotificationContainer, NotificationManager } from "react-notifications";
import contactImage from "./../media/common/contact.svg";
import "react-notifications/lib/notifications.css";

function Reports() {
  const { authState } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const handleReportSubmit = async (values, { resetForm }) => {
    try {
      setLoading(true);
      const response = await createReport(values, authState.token);
      setLoading(false);

      if (response.statusText === "OK") {
        resetForm();
        NotificationManager.success("Your Report Was Sent Successfuly");
      }
    } catch (error) {}
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleReportSubmit,
  });

  if (loading) return <CustomLoading />;

  if (!authState.isLogedIn) {
    return (
      <FullHeightWrapper>
        <Wrapper wrapperClass="wrapper p-b">
          <h2 className="title center tomato repors-page-title">
            Please Login to Contact us
          </h2>
          <img
            alt="contact us"
            src={contactImage}
            style={{
              width: "50%",
              height: "50%",
              position: "relative",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          />
        </Wrapper>
      </FullHeightWrapper>
    );
  }

  return (
    <FullHeightWrapper>
      <Wrapper wrapperClass="wrapper p-b  m-t-h">
        <h2 className="title center tomato">Do you need help?</h2>
        <ReportForm formik={formik} />
        <NotificationContainer />
      </Wrapper>
    </FullHeightWrapper>
  );
}

export default Reports;
